import { render, staticRenderFns } from "./Scene.vue?vue&type=template&id=c85aa60c&scoped=true&"
import script from "./Scene.vue?vue&type=script&lang=ts&"
export * from "./Scene.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85aa60c",
  null
  
)

export default component.exports